import { defineMessages } from 'react-intl';

export default defineMessages({
  headerTitle: {
    id: 'oauthAuthorize.header.title',
    defaultMessage: 'Give access to your Starbucks account?',
    description:
      'Title for authorizing an application to access Starbucks account',
  },
});
